var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#5f00a0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.484 21.804V6.536H6.536v15.268h11.948zm0-17.412c.592 0 1.106.21 1.542.628.436.418.654.923.654 1.516v15.268c0 .593-.218 1.107-.654 1.542-.436.436-.95.654-1.542.654H6.536c-.593 0-1.107-.218-1.543-.654-.435-.435-.653-.95-.653-1.542V6.536c0-.593.218-1.098.653-1.516.436-.419.95-.628 1.543-.628h11.948zM15.216 0v2.196H2.144v15.268H0V2.196C0 1.603.21 1.09.627.654 1.046.218 1.551 0 2.144 0h13.072z",
    transform: "translate(-562 -374) translate(562 374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconGreen);
export default __webpack_public_path__ + "static/media/copy_icon_green.eaf6d7ec7f0119ea787ac2c9b81d4f6d.svg";
export { ForwardRef as ReactComponent };